// Version : 0.0.1
// Author : VIGNESH

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** FETCH GOLD LOAN COLLECTION LIST DETAILS START *********************** */
export const goldLoanCollectionListGet = (listData: any) => {
	const data = {
		GetGoldLoanCollectionReportToken: listData,
	};
	const url = `${API_URL}goldLoanRepaymentCollection`;
	return makeApiCall(url, data);
};
/** ***************** FETCH GOLD LOAN COLLECTION LIST DETAILS END *********************** */
